/**
 * Sticky Add-to-Cart intentionally disabled.
 * The regular product form and its Add-to-Cart button remain unchanged.
 */
(function () {
  'use strict';

  var style = document.createElement('style');
  style.id = 'disable-sticky-add-to-cart';
  style.textContent = [
    'sticky-add-to-cart,',
    '.sticky-add-to-cart,',
    '[class*="sticky-add-to-cart"] {',
    '  display: none !important;',
    '  visibility: hidden !important;',
    '  pointer-events: none !important;',
    '}'
  ].join('\n');

  document.head.appendChild(style);
})();
